import React from "react";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { usePluginServices } from "@/hooks/api/use-plugins";

import { ComponentLoader } from "../componentLoader/component-loader";
import { DynamicField } from "./dynamic-field";
import { DynamicFieldType } from "./types";

export function ServiceField({
	field,
	dynamicField,
	service,
}: {
	field: any;
	dynamicField: any;
	onChange?: (value: string) => void;
	label?: string;
	service: string;
}) {
	const { data: servicesPlugins = [], isLoading: isServicesPluginsLoading } = usePluginServices(service);

	const { control, setValue } = useFormContext();

	return (
		<>
			<ComponentLoader loading={isServicesPluginsLoading} />
			<Grid container spacing={2}>
				<Grid size={{ md: 12, xs: 12 }}>
					<DynamicField
						control={control}
						type={DynamicFieldType.SELECT}
						name={field.name}
						label={dynamicField.label}
						onChange={(value) => setValue(field.name, value)}
						dynamicField={{
							name: field.name,
							required: true,
							label: dynamicField.label,
							type: DynamicFieldType.SELECT,
              showPlaceholder: isServicesPluginsLoading,
							placeholder: dynamicField.placeholder,
							options: servicesPlugins?.map((plugin: any) => ({ value: plugin.id, label: plugin.title })),
						}}
					/>
				</Grid>
			</Grid>
		</>
	);
}
